import React from 'react';
import logo_w from '../../assets/logo-w.png';
import logo_b from '../../assets/logo-w.png';
import './Logo.scss';

export default class Logo extends React.Component {
  render() {
    return (
      <div className="Logo">
        <img src={logo_b} alt={'Daimler'} />
      </div>
    );
  }
}

